exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#main-container[data-v-4fcef22f] {\n  background: url(\"/meldeportal/static/images/login_background.jpg\");\n  background-size: cover;\n}\n", ""]);

// exports
